import { FeatureFlag } from '../FeatureFlag';

/**
 * When enabled, shows the mosaic gutter option in workspace settings.
 * This allows users to configure visual spacing between widgets in mosaic layout.
 */
export const enableMosaicGutterOption = new FeatureFlag({
    key: 'enable-mosaic-gutter-option',
    createdOn: '2026-02-04',
    defaultValue: false,
});
